import React from "react";

import { Presenter } from "./Presenter";

import { Props } from "../../types/RuledLineList01";

export const RuledLineList01: React.VFC<Props> = (props) => {
  return <Presenter {...props} />;
};
